(function () {
  'use strict';

  /*
   * ==========================================================
   * CPAP STORE LOCATOR
   * ==========================================================
   *
   * This file is loaded through Shopify CDN using:
   *
   * <script
   *   src="{{ 'cpap-store-locator.js' | asset_url }}"
   *   defer
   * ></script>
   *
   * Google Maps is loaded separately by the Liquid section.
   *
   * ==========================================================
   */

  const instances = new Map();

  let googleMapsReady = false;


  /*
   * ==========================================================
   * GOOGLE MAPS READY CALLBACK
   * ==========================================================
   */

  window.CPAPStoreLocatorGoogleReady = function () {

    googleMapsReady = true;

    instances.forEach(function (instance) {
      instance.initMap();
    });

  };


  /*
   * ==========================================================
   * MAIN LOCATOR OBJECT
   * ==========================================================
   */

  window.CPAPStoreLocator = {

    init: function (sectionId) {

      if (!sectionId) {
        return;
      }

      /*
       * Prevent duplicate initialization.
       */

      if (instances.has(sectionId)) {

        const existing = instances.get(sectionId);

        if (
          existing &&
          document.getElementById('store-locator-' + sectionId)
        ) {
          existing.refresh();
          return;
        }

        instances.delete(sectionId);
      }


      const root = document.getElementById(
        'store-locator-' + sectionId
      );

      if (!root) {
        return;
      }


      const instance = createLocator(
        sectionId,
        root
      );

      instances.set(
        sectionId,
        instance
      );

      instance.init();

    },


    destroy: function (sectionId) {

      const instance = instances.get(sectionId);

      if (!instance) {
        return;
      }

      instance.destroy();

      instances.delete(sectionId);

    },


    refresh: function (sectionId) {

      const instance = instances.get(sectionId);

      if (instance) {
        instance.refresh();
      }

    }

  };


  /*
   * ==========================================================
   * CREATE LOCATOR
   * ==========================================================
   */

  function createLocator(sectionId, root) {

    let map = null;

    let markers = [];

    let userLocation = null;

    let locations = [];

    let initialized = false;

    let eventsBound = false;


    /*
     * ----------------------------------------------------------
     * ELEMENTS
     * ----------------------------------------------------------
     */

    const elements = {

      searchInput: root.querySelector(
        '#location-search-' + sectionId
      ),

      searchButton: root.querySelector(
        '#search-btn-' + sectionId
      ),

      searchText: root.querySelector(
        '#search-text-' + sectionId
      ),

      locationButton: root.querySelector(
        '#geolocation-btn-' + sectionId
      ),

      locationText: root.querySelector(
        '#location-text-' + sectionId
      ),

      map: root.querySelector(
        '#map-' + sectionId
      ),

      locationsList: root.querySelector(
        '#locations-list-' + sectionId
      ),

      locationsTitle: root.querySelector(
        '#locations-title-' + sectionId
      ),

      locationsCount: root.querySelector(
        '#locations-count-' + sectionId
      )

    };


    /*
     * ==========================================================
     * INITIALIZE
     * ==========================================================
     */

    function init() {

      collectLocations();

      bindEvents();

      initialized = true;

      if (googleMapsReady) {
        initMap();
      }

    }


    /*
     * ==========================================================
     * COLLECT LOCATION DATA
     * ==========================================================
     */

    function collectLocations() {

      locations = [];

      if (!elements.locationsList) {
        return;
      }


      const cards =
        elements.locationsList.querySelectorAll(
          '.cpap-locator__card'
        );


      cards.forEach(function (card) {

        const lat = parseFloat(
          card.dataset.lat
        );

        const lng = parseFloat(
          card.dataset.lng
        );


        /*
         * Ignore locations without valid coordinates.
         */

        if (
          Number.isNaN(lat) ||
          Number.isNaN(lng)
        ) {
          return;
        }


        locations.push({

          id: card.dataset.id,

          lat: lat,

          lng: lng,

          element: card,

          distance: null,

          marker: null

        });

      });

    }


    /*
     * ==========================================================
     * BIND EVENTS
     * ==========================================================
     */

    function bindEvents() {

      if (eventsBound) {
        return;
      }

      eventsBound = true;


      /*
       * SEARCH BUTTON
       */

      if (elements.searchButton) {

        elements.searchButton.addEventListener(
          'click',
          function () {

            performSearch();

          }
        );

      }


      /*
       * ENTER KEY
       */

      if (elements.searchInput) {

        elements.searchInput.addEventListener(
          'keydown',
          function (event) {

            if (event.key === 'Enter') {

              event.preventDefault();

              performSearch();

            }

          }
        );

      }


      /*
       * USE LOCATION
       */

      if (elements.locationButton) {

        elements.locationButton.addEventListener(
          'click',
          function () {

            useCurrentLocation();

          }
        );

      }


      /*
       * LOCATION CARDS
       */

      locations.forEach(function (location) {

        location.element.addEventListener(
          'click',
          function (event) {

            /*
             * Don't trigger card selection when clicking
             * appointment or phone links.
             */

            if (
              event.target.closest('a')
            ) {
              return;
            }

            selectLocation(location);

          }
        );

      });

    }


    /*
     * ==========================================================
     * INITIALIZE GOOGLE MAP
     * ==========================================================
     */

    function initMap() {

      if (!initialized) {
        return;
      }

      if (!elements.map) {
        return;
      }

      if (
        !window.google ||
        !window.google.maps
      ) {
        return;
      }


      /*
       * Prevent unnecessary recreation.
       */

      if (map) {

        updateMarkers();

        return;

      }


      try {

        /*
         * Default center: Canada.
         *
         * Initial map position set to broad Canadian view.
         * It will move when the user searches or uses
         * their location.
         */

        map = new google.maps.Map(
          elements.map,
          {

            center: {
              lat: 43.6532,
              lng: -79.3832
            },

            zoom: 7,

            mapTypeControl: false,

            streetViewControl: false,

            fullscreenControl: true,

            zoomControl: true,

            gestureHandling: 'greedy',

            styles: [

              {
                featureType: 'all',

                elementType: 'geometry',

                stylers: [
                  {
                    color: '#f8fafc'
                  }
                ]

              },

              {
                featureType: 'water',

                elementType: 'geometry',

                stylers: [
                  {
                    color: '#dfe8f2'
                  }
                ]

              },

              {
                featureType: 'road',

                elementType: 'geometry',

                stylers: [
                  {
                    color: '#ffffff'
                  }
                ]

              },

              {
                featureType: 'road',

                elementType: 'geometry.stroke',

                stylers: [
                  {
                    color: '#d9e2ec'
                  }
                ]

              },

              {
                featureType: 'poi',

                stylers: [
                  {
                    visibility: 'off'
                  }
                ]

              },

              {
                featureType: 'transit',

                stylers: [
                  {
                    visibility: 'off'
                  }
                ]

              }

            ]

          }
        );


        updateMarkers();


      } catch (error) {

        console.error(
          'CPAP Store Locator: Unable to initialize Google Maps.',
          error
        );

        showMapError();

      }

    }


    /*
     * ==========================================================
     * MAP ERROR
     * ==========================================================
     */

    function showMapError() {

      if (!elements.map) {
        return;
      }

      elements.map.innerHTML = `
        <div class="cpap-locator__map-error">
          <strong>Map unavailable</strong>
          <span>Please try again later.</span>
        </div>
      `;

    }


    /*
     * ==========================================================
     * SEARCH
     * ==========================================================
     */

    function performSearch() {

      const query =
        elements.searchInput
          ? elements.searchInput.value.trim()
          : '';


      if (!query) {

        if (elements.searchInput) {
          elements.searchInput.focus();
        }

        return;

      }


      if (
        !window.google ||
        !window.google.maps
      ) {

        return;

      }


      setSearchLoading(true);


      const geocoder =
        new google.maps.Geocoder();


      geocoder.geocode(
        {
          address: query,
          componentRestrictions: {
            country: 'CA'
          }
        },

        function (results, status) {

          setSearchLoading(false);


          if (
            status === 'OK' &&
            results &&
            results.length > 0
          ) {

            const location =
              results[0].geometry.location;


            userLocation = {

              lat: location.lat(),

              lng: location.lng()

            };


            updateDistancesAndLocations();


            if (map) {

              map.panTo(userLocation);

              map.setZoom(11);

            }


            updateMarkers();


          } else {

            showSearchError();

          }

        }

      );

    }


    /*
     * ==========================================================
     * SEARCH LOADING STATE
     * ==========================================================
     */

    function setSearchLoading(loading) {

      if (
        !elements.searchButton ||
        !elements.searchText
      ) {
        return;
      }


      if (loading) {

        elements.searchButton.disabled = true;

        elements.searchText.textContent =
          'Searching...';

      } else {

        elements.searchButton.disabled = false;

        elements.searchText.textContent =
          elements.searchButton.dataset.defaultText ||
          'Search';

      }

    }


    /*
     * ==========================================================
     * SEARCH ERROR
     * ==========================================================
     */

    function showSearchError() {

      if (!elements.searchInput) {
        return;
      }


      elements.searchInput.classList.add(
        'cpap-locator__input--error'
      );


      setTimeout(function () {

        elements.searchInput.classList.remove(
          'cpap-locator__input--error'
        );

      }, 2000);

    }


    /*
     * ==========================================================
     * USE CURRENT LOCATION
     * ==========================================================
     */

    function useCurrentLocation() {

      if (
        !navigator.geolocation
      ) {

        return;

      }


      setLocationLoading(true);


      navigator.geolocation.getCurrentPosition(

        function (position) {

          userLocation = {

            lat: position.coords.latitude,

            lng: position.coords.longitude

          };


          updateDistancesAndLocations();


          if (map) {

            map.panTo(userLocation);

            map.setZoom(11);

          }


          updateMarkers();

          setLocationLoading(false);

        },

        function (error) {

          console.warn(
            'CPAP Store Locator: Geolocation failed.',
            error
          );

          setLocationLoading(false);

        },

        {

          enableHighAccuracy: false,

          timeout: 10000,

          maximumAge: 300000

        }

      );

    }


    /*
     * ==========================================================
     * LOCATION BUTTON LOADING
     * ==========================================================
     */

    function setLocationLoading(loading) {

      if (
        !elements.locationButton ||
        !elements.locationText
      ) {
        return;
      }


      if (loading) {

        elements.locationButton.disabled = true;

        elements.locationText.textContent =
          'Locating...';

      } else {

        elements.locationButton.disabled = false;

        elements.locationText.textContent =
          elements.locationButton.dataset.defaultText ||
          'Use My Location';

      }

    }


    /*
     * ==========================================================
     * HAVERSINE DISTANCE
     * ==========================================================
     */

    function calculateDistance(
      lat1,
      lng1,
      lat2,
      lng2
    ) {

      const earthRadius = 6371;

      const dLat =
        (lat2 - lat1) *
        Math.PI /
        180;

      const dLng =
        (lng2 - lng1) *
        Math.PI /
        180;


      const a =

        Math.sin(dLat / 2) *
        Math.sin(dLat / 2)

        +

        Math.cos(
          lat1 *
          Math.PI /
          180
        )

        *

        Math.cos(
          lat2 *
          Math.PI /
          180
        )

        *

        Math.sin(dLng / 2) *
        Math.sin(dLng / 2);


      const c =
        2 *
        Math.atan2(
          Math.sqrt(a),
          Math.sqrt(1 - a)
        );


      return earthRadius * c;

    }


    /*
     * ==========================================================
     * UPDATE DISTANCES
     * ==========================================================
     */

    function updateDistancesAndLocations() {

      if (!userLocation) {
        return;
      }


      locations.forEach(function (location) {

        location.distance =
          calculateDistance(
            userLocation.lat,
            userLocation.lng,
            location.lat,
            location.lng
          );


        const distanceElement =
          location.element.querySelector(
            '[data-distance]'
          );


        if (distanceElement) {

          distanceElement.textContent =
            formatDistance(
              location.distance
            );

          distanceElement.style.display =
            'inline-flex';

        }

      });


      /*
       * Sort closest first.
       */

      locations.sort(
        function (a, b) {

          return (
            a.distance -
            b.distance
          );

        }
      );


      /*
       * Show only nearest five.
       */

      const visibleLocations =
        locations.slice(0, 5);


      locations.forEach(
        function (location) {

          location.element.style.display =
            'none';

        }
      );


      visibleLocations.forEach(
        function (location) {

          location.element.style.display =
            '';

          elements.locationsList.appendChild(
            location.element
          );

        }
      );


      /*
       * Update heading.
       */

      if (elements.locationsTitle) {

        elements.locationsTitle.textContent =
          'Nearest Locations';

      }


      /*
       * Update count.
       */

      if (elements.locationsCount) {

        const count =
          visibleLocations.length;

        elements.locationsCount.textContent =
          count +
          (count === 1
            ? ' location'
            : ' locations');

      }

    }


    /*
     * ==========================================================
     * FORMAT DISTANCE
     * ==========================================================
     */

    function formatDistance(distance) {

      if (distance < 1) {

        return Math.round(
          distance * 1000
        ) + ' m';

      }


      return (
        distance.toFixed(1) +
        ' km'
      );

    }

/*
     * ==========================================================
     * UPDATE MARKERS
     * ==========================================================
     */

    function updateMarkers() {

      if (
        !map ||
        !window.google ||
        !window.google.maps
      ) {
        return;
      }


      /*
       * Remove existing markers.
       */

      markers.forEach(
        function (marker) {

          marker.setMap(null);

        }
      );


      markers = [];


      /*
       * SVG Location Pin Path (standard map marker pin shape)
       */
      const pinSvgPath = 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z';


      /*
       * Only create markers for visible locations.
       */

      const visibleLocations =
        locations.filter(
          function (location) {

            return (
              location.element.style.display !==
              'none'
            );

          }
        );


      visibleLocations.forEach(
        function (location) {

          const marker =
            new google.maps.Marker({

              position: {

                lat: location.lat,

                lng: location.lng

              },

              map: map,

              title:
                getLocationName(
                  location.element
                ),

              icon: {

                path: pinSvgPath,

                scale: 1.5,

                fillColor: '#002d72',

                fillOpacity: 1,

                strokeColor: '#ffffff',

                strokeWeight: 1.5,

                anchor: new google.maps.Point(12, 22)

              }

            });


          marker.addListener(
            'click',
            function () {

              selectLocation(
                location,
                false
              );

            }
          );


          location.marker = marker;

          markers.push(marker);

        }
      );


      /*
       * Add user location marker.
       */

      if (userLocation) {

        const userMarker =
          new google.maps.Marker({

            position: userLocation,

            map: map,

            title: 'Your location',

            icon: {

              path: pinSvgPath,

              scale: 1.5,

              fillColor: '#d93025', // Distinct red color for user location

              fillOpacity: 1,

              strokeColor: '#ffffff',

              strokeWeight: 1.5,

              anchor: new google.maps.Point(12, 22)

            }

          });


        markers.push(userMarker);

      }

    }


    /*
     * ==========================================================
     * GET LOCATION NAME
     * ==========================================================
     */

    function getLocationName(card) {

      const name =
        card.querySelector(
          '.cpap-locator__location-name'
        );


      return name
        ? name.textContent.trim()
        : 'Store Location';

    }


    /*
     * ==========================================================
     * SELECT LOCATION
     * ==========================================================
     */

    function selectLocation(
      location,
      centerMap = true
    ) {

      /*
       * Remove active state.
       */

      root
        .querySelectorAll(
          '.cpap-locator__card.active'
        )
        .forEach(
          function (card) {

            card.classList.remove(
              'active'
            );

          }
        );


      /*
       * Activate selected card.
       */

      location.element.classList.add(
        'active'
      );


      /*
       * Center map.
       */

      if (
        centerMap &&
        map
      ) {

        map.panTo({

          lat: location.lat,

          lng: location.lng

        });


        map.setZoom(14);

      }


      /*
       * Bounce marker.
       */

      if (location.marker) {

        location.marker.setAnimation(
          google.maps.Animation.BOUNCE
        );


        setTimeout(
          function () {

            if (location.marker) {

              location.marker.setAnimation(
                null
              );

            }

          },
          700
        );

      }

    }


    /*
     * ==========================================================
     * REFRESH
     * ==========================================================
     */

    function refresh() {

      collectLocations();

      bindEvents();

      if (map) {
        updateMarkers();
      }

    }


    /*
     * ==========================================================
     * DESTROY
     * ==========================================================
     */

    function destroy() {

      markers.forEach(
        function (marker) {

          marker.setMap(null);

        }
      );


      markers = [];

      map = null;

      initialized = false;

      eventsBound = false;

    }


    /*
     * ==========================================================
     * PUBLIC INSTANCE
     * ==========================================================
     */

    return {

      init: init,

      initMap: initMap,

      refresh: refresh,

      destroy: destroy

    };

  }


  /*
   * ==========================================================
   * INITIALIZE ALL EXISTING LOCATORS
   * ==========================================================
   */

  function initAllLocators() {

    document
      .querySelectorAll(
        '.cpap-locator'
      )
      .forEach(
        function (locator) {

          const sectionId =
            locator.id.replace(
              'store-locator-',
              ''
            );


          if (sectionId) {

            window.CPAPStoreLocator.init(
              sectionId
            );

          }

        }
      );

  }


  /*
   * ==========================================================
   * DOM READY
   * ==========================================================
   */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initAllLocators
    );

  } else {

    initAllLocators();

  }


  /*
   * ==========================================================
   * SHOPIFY THEME EDITOR SUPPORT
   * ==========================================================
   */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      const sectionId =
        event.detail &&
        event.detail.sectionId;


      if (sectionId) {

        window.CPAPStoreLocator.init(
          sectionId
        );

      }

    }
  );


  document.addEventListener(
    'shopify:section:unload',
    function (event) {

      const sectionId =
        event.detail &&
        event.detail.sectionId;


      if (sectionId) {

        window.CPAPStoreLocator.destroy(
          sectionId
        );

      }

    }
  );


})();